import React from 'react';
import { shape } from 'prop-types';
import { getShippingTemplate } from '../helpers/shipping-helper';
import { productShape } from '../helpers/pod-fulfillment-utils';
import { dataModel } from '../../components/dataModel';
import { EmptyShippingMessage } from '../partials/shipping/EmptyShippingMessage';
import './fulfillment-pod-shipping.scss';

export const FulfillmentPodShipping = ({ product }) => {
  const ShippingComponent = getShippingTemplate({ product });

  if (!ShippingComponent) {
    return EmptyShippingMessage;
  }

  return (
    <ShippingComponent product={product} />
  );
};

FulfillmentPodShipping.propTypes = {
  product: shape({ productShape }).isRequired,
};

FulfillmentPodShipping.dataModel = dataModel;
